const updateTitle = (uiState) => {
  const { query } = uiState[""] || {};
  const titleSuffix = query ? `for "${query}"` : "";
  document.getElementById("chamfr-search-results-for-query").innerHTML =
    titleSuffix;
};

export const chamfrSearchForQueryMiddleware = ({ instantSearchInstance }) => {
  return {
    onStateChange({ uiState }) {
      updateTitle(uiState);
    },
    subscribe() {
      if (!instantSearchInstance._chamfrSearchForQueryInitialized) {
        instantSearchInstance._chamfrSearchForQueryInitialized = true;
        updateTitle(instantSearchInstance._initialUiState);
      }
    },
    unsubscribe() {},
  };
};
